import type { Viewport } from '../hex/camera2d';
import type { Tile } from '../hex/types';
import { resourceSummaryLines } from '../map/resourceUtils';
import type { HexMapState } from './renderer';
import { t } from '../../i18n/translations';

export function drawTooltip(
    ctx: CanvasRenderingContext2D,
    state: HexMapState,
    viewport: Viewport,
): void {
    if (!state.hover || state.isModalHover) return;
    const tile: Tile = state.hover;
    const pad = 8;
    const lang = state.config.ui.language;
    const lines = state.discoveredTileIds.has(tile.id)
        ? (() => {
              const biomeLabel = t(lang, `biome.${tile.biome.type}`);
              const biomeText =
                  biomeLabel === `biome.${tile.biome.type}` ? tile.biome.type : biomeLabel;
              const resourceLines = resourceSummaryLines(tile, lang);
              return [
                  t(lang, 'tooltip.id', tile.id),
                  t(lang, 'tooltip.qrs', tile.position.q, tile.position.r, tile.position.s),
                  t(lang, 'tooltip.biome', biomeText),
                  t(lang, 'tooltip.resourcesHeader'),
                  ...resourceLines,
              ];
          })()
        : [
              t(lang, 'tooltip.id', tile.id),
              t(lang, 'tooltip.qrs', tile.position.q, tile.position.r, tile.position.s),
              t(lang, 'tooltip.unknown'),
          ];
    ctx.save();
    ctx.font = '12px monospace';
    const widths = lines.map((line) => ctx.measureText(line).width);
    const w = Math.max(...widths) + pad * 2;
    const h = lines.length * 16 + pad * 2;

    let x = state.pointer.x + 12;
    let y = state.pointer.y + 12;
    if (x + w > viewport.width) x -= w + 24;
    if (y + h > viewport.height) y -= h + 24;

    ctx.fillStyle = 'rgba(0,0,0,0.75)';
    ctx.strokeStyle = 'rgba(255,255,255,0.2)';
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.rect(x, y, w, h);
    ctx.fill();
    ctx.stroke();

    ctx.fillStyle = '#f1f1f1';
    ctx.textBaseline = 'top';
    lines.forEach((line, i) => ctx.fillText(line, x + pad, y + pad + i * 16));
    ctx.restore();
}
